export { CampingOnBoard } from './campingOnBoard'

export const defaultExtraAtrributes = {
    wantsCampingOnBoard: false
}

export const defaultExtraRequirements = {
    
}